import React, { Component, ErrorInfo, ReactNode } from 'react'
import Typography from '@material-ui/core/Typography'

type Props = { children: ReactNode }

type State = { hasError: boolean }

/** Catches InstantSearch / facet render errors so the rest of the app keeps running. */
export class ProjectsFilterErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Projects filter panel error:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
          Filters could not be loaded. Try closing and opening again, or refresh the page.
        </Typography>
      )
    }
    return this.props.children
  }
}
